import { ref } from 'vue';
import dataMasterRepository from '@/repositories/general/dataMasterRepository';

export function useGenLabel() {
  const listLabel = ref([]);

  const getLabel = async (search = '') => {
    try {
      const params = {
        search: search,
      };
      const data = await dataMasterRepository.getLabel(params);
      if (data.data.status === 200) {
        listLabel.value = [];
        data.data.data.label.list.forEach((item) => {
          listLabel.value.push(item);
        });
      }
    } catch (error) {
      console.log(error);
    }
  };

  const saveLabel = async (labelName) => {
    try {
      const params = {
        label_name: labelName,
      };

      await dataMasterRepository.saveLabel(params);
    } catch (error) {
      console.log(error);
    }
  };

  getLabel();

  return { listLabel, getLabel, saveLabel };
}
